// document.addEventListener("DOMContentLoaded", function() {
//   const uploadOption = document.querySelector('input[value="upload"]');
//   const createOption = document.querySelector('input[value="create"]');
//   const fileUploadSection = document.querySelector('.file-upload-section');
// //   const fileUploas = document.querySelector('.cl-upload--wrapper');
//   const gsBuilderBtn = document.querySelector('#gs-builder-btn');
//   const desUpload = document.querySelector('.des-uplooad');
//   const desCreate = document.querySelector('.des-create');

//   if (!uploadOption || !createOption || !fileUploadSection || !gsBuilderBtn || !productSubmitButton || !desUpload || !desCreate) {
//     console.error("One or more elements not found. Check the Liquid template.");
//     return;
//   }

//   function toggleFileUpload() {
//     fileUploadSection.style.display = uploadOption.checked ? "block" : "none";
//  //   fileUploas.style.display = uploadOption.checked ? "none" : "block";
//     gsBuilderBtn.style.display = createOption.checked ? "block" : "none";
//     productSubmitButton.style.display = createOption.checked ? "none" : "block";
//     desUpload.style.display = uploadOption.checked ? "block" : "none";
//     desCreate.style.display = createOption.checked ? "block" : "none";

//     console.log("File upload section is now", fileUploadSection.style.display);
//   //  console.log("File upload section is now a", fileUploas.style.display);
//     console.log("GS Builder Button is now", gsBuilderBtn.style.display);
//     console.log("Product Submit Button is now", productSubmitButton.style.display);
//     console.log("Description Upload is now", desUpload.style.display);
//     console.log("Description Create is now", desCreate.style.display);
//   }

//   uploadOption.addEventListener("change", toggleFileUpload);
//   createOption.addEventListener("change", toggleFileUpload);

//   toggleFileUpload(); // Run on page load
// });



// const variantRadios = document.querySelectorAll('input[name="Select DTF Gang Sheet Sizes:-1"]');

//     if (variantRadios.length > 0 && selectedSizeElement) {
//         // Update selected size when a radio button is clicked
//         variantRadios.forEach(radio => {
//             radio.addEventListener('change', function() {
//                 if (this.checked) {
//                     selectedSizeElement.textContent = this.value;
//                 }
//             });
//         });

//         // Initialize selected size on page load
//         const initialCheckedRadio = document.querySelector('input[name="Select DTF Gang Sheet Sizes:-1"]:checked');
//         if (initialCheckedRadio) {
//             selectedSizeElement.textContent = initialCheckedRadio.value;
//         }
//     }});

document.addEventListener("DOMContentLoaded", function() {
    const tabs = document.querySelectorAll(".tab");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
      tab.addEventListener("click", function() {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        this.classList.add("active");
        document.getElementById(this.dataset.tab).classList.add("active");
      });
    });
  });

// Removed: a DOMContentLoaded handler that moved every product media item except the
// first into a generated <div class="grouped-items"> and wiped the <ul> with innerHTML.
// The only CSS that ever sized that div was scoped to template IDs 19166312366335 and
// 19016415019263, which no longer exist, so the div collapsed to 2px and every image
// after the first became invisible on every product. It also put a <div> directly inside
// a <ul> and reordered the featured image to last. Stock Dawn handles this correctly.

// document.addEventListener("DOMContentLoaded", function() {
//   const fileInput = document.getElementById("gang-sheet-file");
//   const fileUploadText = document.getElementById("file-upload-text");
//   const uploadedFileName = document.getElementById("uploaded-file-name");

//   fileInput.addEventListener("change", function(event) {
//     const file = event.target.files[0];

//     if (file) {
//       fileUploadText.textContent = `Selected: ${file.name}`;
//     } else {
//       fileUploadText.textContent = "Click to choose the file or drag it here";
//       uploadedFileName.style.display = "none";
//     }
//   });
// });
// document.addEventListener("DOMContentLoaded", function() {
//     var fileInput = document.getElementById("gang-sheet-file");
//     var form = document.querySelector("form[data-type='add-to-cart-form']");

//     if (fileInput && form) {
//         fileInput.addEventListener("change", function() {
//             form.setAttribute("data-ajax", "false"); // Disable AJAX
//         });
//     }
// });


